import type { IconProps } from "./types";

export function ChevronDown({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2636 0.263592C12.6151 -0.0878565 13.1856 -0.0878716 13.537 0.263592C13.8884 0.615066 13.8885 1.18559 13.537 1.53703L7.53704 7.53703C7.18561 7.88846 6.61509 7.88839 6.2636 7.53703L0.263604 1.53703C-0.087868 1.18556 -0.087868 0.615064 0.263604 0.263592C0.615078 -0.0878565 1.18558 -0.0878718 1.53704 0.263592L6.90032 5.62687L12.2636 0.263592Z"
        fill={currentColor}
        transform="translate(5.1 8.1)"
      />
    </svg>
  );
}
